import { useEffect } from 'react';

import { ToastMessage, type ToastMessageTone } from '@shared/ui/toast-message';

import type { ToastKind } from './toast.constant';
import type { ToastItem } from './toast.store';
import { TOAST_TEXT } from './toast.text';

/**
 * 명령형 토스트의 종류 4개 → `Toast` atom(Figma `Toast`)의 tone 3개.
 * Figma 에 info · warning 모양이 따로 없어 neutral 로 그린다(모양이 생기면 여기만 바꾼다).
 */
const KIND_TONE: Record<ToastKind, ToastMessageTone> = {
  success: 'success',
  error: 'danger',
  info: 'neutral',
  warning: 'neutral',
};

export interface ToastItemViewProps {
  item: ToastItem;
  onDismiss: (id: string) => void;
}

/** 토스트 한 건: 표시 시간이 지나면 닫고, 모양은 `ToastMessage` atom 이 그린다. */
export function ToastItemView({ item, onDismiss }: ToastItemViewProps) {
  useEffect(() => {
    if (item.durationMs <= 0) return;
    const timer = window.setTimeout(() => onDismiss(item.id), item.durationMs);
    return () => window.clearTimeout(timer);
  }, [item.id, item.durationMs, item.text, onDismiss]);

  return (
    <ToastMessage
      tone={KIND_TONE[item.kind]}
      data-kind={item.kind}
      action={{ label: TOAST_TEXT.close, onClick: () => onDismiss(item.id) }}
      className="pointer-events-auto max-w-full"
    >
      {item.text}
    </ToastMessage>
  );
}
